import React from 'react';
import { X, Check } from 'lucide-react';
const comparison = [{
  sit: 'Ya armaste tu primera cartera, ¿y ahora?',
  sin: 'Improvisás el seguimiento',
  con: 'Sistema de seguimiento con IA, listo'
}, {
  sit: 'Varios clientes a la vez',
  sin: 'Se te pierden seguimientos',
  con: 'Protocolo de etiquetas caliente/tibio/frío'
}, {
  sit: 'Querés crecer más allá de referidos',
  sin: 'Dependés solo del boca en boca',
  con: 'Plan de contenido IG + referidos en 3 pasos'
}, {
  sit: 'Necesitás proyectar ingresos a futuro',
  sin: 'Calculás a ojo',
  con: 'Calculadora de comisiones con proyección anual'
}];
export function UpsellComparison() {
  return <section className="py-20 bg-white px-6 lg:px-8" data-id="element-293">
      <div className="max-w-4xl mx-auto" data-id="element-294">
        <div className="text-center mb-12" data-id="element-295">
          <h2 className="text-2xl md:text-4xl font-extrabold text-brand-navy mb-4" data-id="element-296">
            ¿Por qué sumar el Kit Cartera Activa?
          </h2>
          <p className="text-lg text-brand-navy/70" data-id="element-297">
            La diferencia entre tener un par de propiedades y tener un negocio
            predecible.
          </p>
        </div>

        <div className="overflow-x-auto" data-id="element-298">
          <div className="min-w-[600px]" data-id="element-299">
            {/* Header row */}
            <div className="grid grid-cols-[25%_37.5%_37.5%] items-end" data-id="element-300">
              <div className="p-4 text-brand-navy font-bold" data-id="element-301">Situación</div>
              <div className="p-4 text-brand-navy/60 font-bold" data-id="element-302">Sin Kit</div>
              <div className="p-4 font-bold text-brand-accent border-b-2 border-brand-accent bg-brand-light rounded-t-xl" data-id="element-303">
                Con Kit Cartera Activa
              </div>
            </div>

            {/* Body rows */}
            {comparison.map((row, i) => <div key={i} className="grid grid-cols-[25%_37.5%_37.5%] border-b border-brand-light" data-id="element-304">
                <div className="p-4 text-brand-navy font-bold" data-id="element-305">{row.sit}</div>
                <div className="p-4 flex items-start gap-2 text-gray-400" data-id="element-306">
                  <X className="w-5 h-5 text-red-500 shrink-0 mt-0.5" data-id="element-307" />
                  <span data-id="element-308">{row.sin}</span>
                </div>
                <div className="p-4 flex items-start gap-2 text-brand-navy font-bold bg-brand-light" data-id="element-309">
                  <Check className="w-5 h-5 text-brand-green shrink-0 mt-0.5" data-id="element-310" />
                  <span data-id="element-311">{row.con}</span>
                </div>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}